const host = "http://moko:5000"
const host_ws = "ws://moko:5000"

const host_read_camera = "/read-camera"
const host_delete_camera = "/delete-camera"
const host_stream = "/stream"
const host_get_camera_backend = "/get-camera-backend"
const host_set_camera_backend = "/set-camera-backend"
const host_camera_config = "/camera-config"
const host_save_camera = "/save-camera"

export {
    host,
    host_ws,
    host_read_camera,
    host_delete_camera,
    host_stream,
    host_camera_config,
    host_get_camera_backend,
    host_set_camera_backend,
    host_save_camera
};